import setDebug from 'debug';
import type {
  CroppedInfo,
  StrategiesNameMap,
  StrategyWithCropInfo,
} from '@seek/image-service-types';
import type { AssetType } from '@seek/brand-types';

import { getAssetStrategies } from '../utils/getAssetStrategies';
import { callImageService } from '../utils/fetchAsset';

const debug = setDebug('image-service-uploader');

interface UploadAssetPostData {
  strategies?: StrategiesNameMap[] | StrategyWithCropInfo[];
}

interface PatchAssetParams {
  type: AssetType;
  id: string;
  croppedInfo?: CroppedInfo;
}

export const patchAsset = async ({
  type,
  id,
  croppedInfo,
}: PatchAssetParams) => {
  const postData: UploadAssetPostData = {
    strategies: getAssetStrategies(type, croppedInfo),
  };

  const body = JSON.stringify(postData);
  const headers = {
    'Content-Type': 'application/json',
  };

  debug(`Updating ${type} Id`, id);

  const response = await callImageService({
    headers,
    body,
    id,
  });

  if (!response.ok) {
    debug(`Failed to patch ${type} to image-service`);
    throw new Error(`Failed to patch ${type}`);
  }

  return response.json();
};
